import * as React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {FormControl, InputLabel, MenuItem, MenuProps, Select, SelectChangeEvent} from "@mui/material";
import {merge} from "lodash";
import {FormControlProps} from "@mui/material/FormControl/FormControl";
import {StyledInputLabel} from "../providers/layout/LayoutProvider";

let nextId = 0;

export type SelectOption = {
   id: any
   name: string,
   label?: string
}

export interface FormInputSelectProps extends FormControlProps {
   name: string;
   control?: any;
   label: string;
   setValue?: any;
   errorMessage?: string;
   options: SelectOption[]
   required?: boolean
   onSelectChange?: (e: SelectChangeEvent<any>) => void
   icon?: React.ReactNode
}


export const FormInputSelect: React.FC<FormInputSelectProps> = ({
                                                                   name,
                                                                   label,
                                                                   options,
                                                                   errorMessage,
                                                                   required,
                                                                   onSelectChange,
                                                                   icon,
                                                                   ...rest
                                                                }) => {
   let labelid = "simple-select-" + (++nextId);

   const {style} = rest;

   const methods = useFormContext();
   const {control, formState: {errors}} = methods;
   const showError = !!errors[name];

   const newStyle = merge(style, {
      marginBottom: '8px',
   });

   const selectStyle = {
      backgroundColor: 'transparent',
      border: showError ? '1px solid rgb(240,0,0)' : '1px solid #d0d0d0',
      borderRadius: 2,
      flexGrow: 1
   };

   const ITEM_HEIGHT = 48;
   const ITEM_PADDING_TOP = 8;

   const menuProps = {
      anchorOrigin: {
         vertical: "bottom",
         horizontal: "left"
      },
      transformOrigin: {
         vertical: "top",
         horizontal: "left"
      },
      PaperProps: {
         style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
         }
      },
   } as MenuProps;

   return (
      <FormControl fullWidth variant={"filled"} margin={"none"} size={"small"} style={newStyle} {...rest}>
         <InputLabel id={labelid} shrink={true} sx={{zIndex: 0}}>
            <StyledInputLabel type={"main"} variant={"body1"} component={"span"}>
               <div style={{display: 'flex', alignItems: 'middle', gap: '10px'}}>
                  {icon && icon} {label}
               </div>
            </StyledInputLabel>
         </InputLabel>
         <Controller
            render={({field: {onChange, value}, fieldState: {error}}) => {
               return <><Select
                  disableUnderline
                  style={selectStyle}
                  labelId={labelid}
                  MenuProps={menuProps}
                  onChange={(e) => {
                     onChange(e);
                     if (onSelectChange) {
                        onSelectChange(e)
                     }
                  }}
                  value={value || ''}
                  label={label}
                  renderValue={(selected) => {
                     const option = options?.find(option => option.id === selected)
                     return <div>{option?.label || option?.name}</div>
                  }}
               >
                  {options?.map((option) => {
                     return <MenuItem value={option.id} dense={true} key={'select_' + option.id}>
                        {option.name}
                     </MenuItem>
                  })}
               </Select>
               </>
            }}
            control={control}
            name={name}
         />
      </FormControl>
   );
};
